module.exports = __webpack_public_path__ + "img/a9.0e132c1f.svg";